import { ChaoticCircles } from '@journ/reckoner/chaotic-circles'
import { createFileRoute, Outlet, useParams } from '@tanstack/react-router'
import { useContainer } from '@thom/folio-ui/app/container'
import { ticketArt } from '@thom/folio-ui/app/ticket-art'
import { useTheme } from '@thom/folio-ui/app/use-theme'
import { ProjectNav } from '@thom/folio-ui/pages/project/nav'
import { useEffect } from 'react'

const ComplexityRepresentation = () => {
	const { appearance } = useTheme()

	return (
		<ChaoticCircles
			appearance={appearance}
			store={ticketArt}
			className='pointer-events-none fixed top-0 left-0 z-0 aspect-square h-dvw translate-y-[-7.5dvw] opacity-75 lg:h-dvh lg:translate-x-[50dvw] lg:translate-y-[-10dvh] lg:opacity-50'
		/>
	)
}

const ProjectNavWrapper = () => {
	const { lastProject } = useContainer()
	const { client, domain, slug } = useParams({ from: '/_authenticated/$client/$domain/$slug' })
	useEffect(() => lastProject.remember({ client, domain, slug }), [lastProject, client, domain, slug])

	return <ProjectNav client={client} domain={domain} slug={slug} />
}

const ProjectLayout = () => {
	return (
		<>
			<ComplexityRepresentation />
			<div className='relative isolate space-y-6'>
				<ProjectNavWrapper />
				<Outlet />
			</div>
		</>
	)
}

export const Route = createFileRoute('/_authenticated/$client/$domain/$slug')({
	component: ProjectLayout,
})
